import { render } from "./proofCollect.vue?vue&type=template&id=38574bf4&scoped=true"
import script from "./proofCollect.vue?vue&type=script&lang=js"
export * from "./proofCollect.vue?vue&type=script&lang=js"

import "./proofCollect.vue?vue&type=style&index=0&id=38574bf4&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38574bf4"]])

export default __exports__